import React from 'react'
import './App.scss'
import AppContent from './components/index'
import GlobalContext from './contexts/index'

const App = () => {
  return (
    // Global context to detect what the menu status.
    <GlobalContext >
      <AppContent/>
    </GlobalContext>
  )
}

export default App
